import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type {
  UpdateOperationChainItemMutationRequest,
  UpdateOperationChainItemMutationResponse,
} from "../types/UpdateOperationChainItem"

type UpdateOperationChainItemClient = typeof client<
  UpdateOperationChainItemMutationResponse,
  Error,
  UpdateOperationChainItemMutationRequest
>
type UpdateOperationChainItem = {
  data: UpdateOperationChainItemMutationResponse
  error: Error
  request: UpdateOperationChainItemMutationRequest
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<UpdateOperationChainItemClient>>
  client: {
    parameters: Partial<Parameters<UpdateOperationChainItemClient>[0]>
    return: Awaited<ReturnType<UpdateOperationChainItemClient>>
  }
}
/**
 * @link /v1/operation-chain/update-operation-chain-item
 */
export function useUpdateOperationChainItem(
  options: {
    mutation?: UseMutationOptions<
      UpdateOperationChainItem["response"],
      UpdateOperationChainItem["error"],
      UpdateOperationChainItem["request"]
    >
    client?: UpdateOperationChainItem["client"]["parameters"]
  } = {}
): UseMutationResult<
  UpdateOperationChainItem["response"],
  UpdateOperationChainItem["error"],
  UpdateOperationChainItem["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    UpdateOperationChainItem["response"],
    UpdateOperationChainItem["error"],
    UpdateOperationChainItem["request"]
  >({
    mutationFn: async (data) => {
      const res = await client<
        UpdateOperationChainItem["data"],
        UpdateOperationChainItem["error"],
        UpdateOperationChainItem["request"]
      >({
        method: "post",
        url: `/v1/operation-chain/update-operation-chain-item`,
        data,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
